import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Hero,
  HeroImageContainer,
  HeroContent,
  Title,
  FeaturesSection,
  FeaturesTitle,
  FeaturesList,
  FeaturesListItem,
  FeaturesListTitle,
  FeaturesListDesc,
  ArtistsGridContainer,
  ArtistsGrid,
} from './InSalonArtistClasses.style';

import seminarImageSrc from '../../../assets/images/education/artist-seminar.jpg';
import detailsImageSrc from '../../../assets/images/education/education_type_3.jpg';
import Icon1 from './assets/icon_01.svg?react';
import Icon2 from './assets/icon_02.svg?react';
import Icon3 from './assets/icon_03.svg?react';
import Icon4 from './assets/icon_04.svg?react';

import { TwoColumnSection } from '../../../components/TwoColumnSection/TwoColumnSection';
import { CTASection } from '../../../components/CTASection/CTASection';
import { EducationBlock } from '../../../components/EducationBlock/EducationBlock';
import { ArtistCard } from '../../../components/ArtistCard/ArtistCard';

import { artists } from './config';

export const InSalonArtistClasses = () => {
  const intl = useIntl();

  return (
    <Root>
      <Hero>
        <HeroImageContainer />
        <HeroContent>
          <Title>
            <FormattedMessage defaultMessage="In-Salon Artist Classes" />
          </Title>
        </HeroContent>
      </Hero>

      <TwoColumnSection
        imageSrc={seminarImageSrc}
        title={intl.formatMessage({
          defaultMessage:
            'Advance your salon skills & stay ahead with exclusive artist seminars',
        })}
        desc={
          <FormattedMessage
            defaultMessage="Elevate your salon game and unlock your team’s full potential with our in-salon artist classes. Led by skilled and experienced members of our Artistic Teams, these immersive, hands-on workshops are tailored to your salon’s needs—empowering your stylists with advanced techniques in coloring, cutting, and styling. Whether you're upskilling your team or staying ahead of trends, these seminars are your ticket to salon excellence."
            tagName="p"
          />
        }
        ctaText={intl.formatMessage({
          defaultMessage: 'REQUEST A CLASS',
        })}
        ctaUrl="/education/request"
      />

      <FeaturesSection>
        <FeaturesTitle>
          <FormattedMessage defaultMessage="What’s included?" />
        </FeaturesTitle>
        <FeaturesList>
          <FeaturesListItem className="--1">
            <Icon1 />
            <FeaturesListTitle>
              <FormattedMessage defaultMessage="Hands-On Learning" />
            </FeaturesListTitle>
            <FeaturesListDesc>
              <FormattedMessage defaultMessage="Your team will train directly with our elite artistic team members, honing techniques in coloring, cutting, barbering, and long hair styling." />
            </FeaturesListDesc>
          </FeaturesListItem>
          <FeaturesListItem className="--2">
            <Icon2 />
            <FeaturesListTitle>
              <FormattedMessage defaultMessage="Materials Provided" />
            </FeaturesListTitle>
            <FeaturesListDesc>
              <FormattedMessage defaultMessage="From products to mannequin stands, we’ve got everything you need for a successful session." />
            </FeaturesListDesc>
          </FeaturesListItem>
          <FeaturesListItem className="--3">
            <Icon3 />
            <FeaturesListTitle>
              <FormattedMessage defaultMessage="Custom Solutions" />
            </FeaturesListTitle>
            <FeaturesListDesc>
              <FormattedMessage defaultMessage="Choose from a range of pre-set modules or build a seminar tailored to your salon’s goals." />
            </FeaturesListDesc>
          </FeaturesListItem>
          <FeaturesListItem className="--4">
            <Icon4 />
            <FeaturesListTitle>
              <FormattedMessage defaultMessage="Flexible Options" />
            </FeaturesListTitle>
            <FeaturesListDesc>
              <FormattedMessage defaultMessage="Seminars can be purchased or redeemed for starting at 2,000,000 Club H Points." />
            </FeaturesListDesc>
          </FeaturesListItem>
        </FeaturesList>
      </FeaturesSection>

      <TwoColumnSection
        imageSrc={detailsImageSrc}
        title={intl.formatMessage({ defaultMessage: 'Additional details:' })}
        desc={
          <span style={{ display: 'block', maxWidth: 275 }}>
            <p>
              <FormattedMessage
                tagName="strong"
                defaultMessage="Mannequin Heads"
              />
              <br />
              <FormattedMessage
                tagName="span"
                defaultMessage="Can be purchased directly from Henkel Consumer Brands Canada"
              />
              <br />
              <br />
              <FormattedMessage
                tagName="strong"
                defaultMessage="Booking & Cancellations"
              />
            </p>
            <TwoColumnSection.List>
              <FormattedMessage
                tagName="li"
                defaultMessage="Book and redeem Club H points at least 30 days before the seminar"
              />
              <FormattedMessage
                tagName="li"
                defaultMessage="Cancellations must be made at least 30 days in advance to avoid fees"
              />
            </TwoColumnSection.List>
          </span>
        }
        reverse
      />

      <CTASection
        title={intl.formatMessage({
          defaultMessage: 'Ready to transform your salon?',
        })}
        desc={
          <span>
            <FormattedMessage
              tagName="span"
              defaultMessage="There’s no better time to invest in your team’s skills and creativity."
            />
            <br />
            <FormattedMessage
              tagName="span"
              defaultMessage="Redeem your Club H points and book your In-Salon Artist Education seminar today."
            />
          </span>
        }
        ctaText={intl.formatMessage({ defaultMessage: 'REQUEST A CLASS' })}
        ctaUrl="/education/request"
      />

      <ArtistsGridContainer>
        <ArtistsGrid>
          {artists.map((artist) => (
            <ArtistCard
              key={artist.socialHandle}
              imageSrc={artist.imageSrc}
              brand={artist.brand}
              name={artist.name}
              role={artist.role}
              socialHandle={artist.socialHandle}
              socialLink={artist.socialLink}
            />
          ))}
        </ArtistsGrid>
      </ArtistsGridContainer>

      <EducationBlock />
    </Root>
  );
};
